module.exports = __webpack_public_path__ + "static/1152156138.0298faa5.jpg";